import { createSelector } from '@reduxjs/toolkit'

import { ApplicationState } from 'redux/Stores/types'

export const selectNavigation = createSelector(
  [
    // Input selectors:
    (state: ApplicationState) => state.NavigationMenuStore.open,
    (state: ApplicationState) => state.NavigationMenuStore.expandedItems
  ],
  (open, expandedItems) => ({
    open,
    expandedItems
  })
)
